<template>
    <div>
		<search-list @search-data="getParams" class="mb16"></search-list>
		<div>
		<table-list

            :columns="columns"
            :data="data"
            :total="total"
            :loading="loading"
            @change-page="getPage"
			@change-size="getSize"
        ></table-list>
		</div>
		<!-- 详情 -->
		<details-modal :n="key" :roomid="roomId" :devicetype="deviceType" :devicetypecn="deviceTypeCn" :roomnumber="roomNumber" :roomstatuscn="roomStatusCn" :unit="unit"></details-modal>
		<!-- 充值 -->
		<recharge-modal :count="counts" :projectfid="projectFid" :devicetype="deviceType" :roomid="roomId"></recharge-modal>
	</div>
</template>

<script type="text/ecmascript-6">
import SearchList from './components/SearchList';
import TableList from 'components/TableList/index';
import DetailsModal from './components/DetailsModal';
import RechargeModal from './components/RechargeModal';
import { getList } from "api/meterRecharge";
export default {
	name:'recharge',
	components: {
		SearchList,
		TableList,
		DetailsModal,
		RechargeModal
	},
	data() {
		return {
			columns:[
				{
					type:'index',
					width:60,
					align:'center'
				},
				{
					title:'项目',
					align:'center',
          key:'projectName'
				},
				{
					title:'房间号',
					align:'center',
          key:'roomNumber'
				},
				{
					title:'楼栋',
					align:'center',
          key:'buildingName'
				},
				{
					title:'楼层',
					align:'center',
                    key:'floorNumber'
				},
				{
					title:'房间状态',
					align:'center',
					key:'roomStatusCn'
				},
				{
					title:'操作',
                    key:'action',
                    width:150,
                    align:'center',
					render:(h,params) => {
						return h('div',[h('Button',{
							props: {
								type:'primary',
								size:'small'
							},
              directives:[
                {
                  name:'p',
                  value:{
                    api:'waterwatt/payment'
                  }
                }
              ],
							style: {
								marginRight: '5px'
							},
							on:{
								click: () => {
									this.counts++;
									this.roomId = params.row.roomId;
									this.deviceType = params.row.deviceType;
									this.projectFid = params.row.projectId
								}
							}
						},'充值'),h('Button',{
							props: {
								type:'ghost',
								size:'small',
							},
              directives:[
                {
                  name:'p',
                  value:{
                    api:'waterwatt/device/detail'
                  }
                }
              ],
							on:{
								click: () => {
									this.key++;
									this.roomId = params.row.roomId;
									this.deviceType = params.row.deviceType;
									if(this.deviceType === 0){
										// 水表
										this.unit = 'm³'
									}else{
										// 电表
										this.unit = 'KWH'
									}
									this.deviceTypeCn = params.row.deviceTypeCn;
									this.roomNumber = params.row.roomNumber;
									this.roomStatusCn = params.row.roomStatusCn
								}
							}
						},'详情')])
					}
				},

			],
			data:[],
			total:0,
			loading:false,
			params:{
				page:1,
				limit:10,
				projectId:"",
				deviceType:1,
				roomStatus:"",
				roomNumber:""
			},
			key:0,
			counts:0,
			roomId:"",
			deviceType:null,
			projectFid:"",
			deviceTypeCn:'',
			roomNumber:'',
			roomStatusCn:'',
			unit:'', // 水与电表单位

		};
	},
	created () {
		this.initList();
	},
	methods: {
		getPage(n) {
			this.params.page = n;
			this.initList();
		},
		initList() {
			getList(this.params).then(res => {
				this.data = res.data.rows;
				this.total = res.data.total;
			})
		},
		getParams(params) {
			this.params = params;
			this.initList();
		},
		getSize(size) {
			this.params.limit = size;
			this.initList();
		}
	}
};
</script>
